export default {
  apiDomain: 'https://api.fakeflighttickets.com',
  crispChat: false,
  stripePK: 'pk_test_1fR6sFCXQ8K3SwxKdrqHAAJM005jcGQhbh',
  stripeSKU: 'sku_EldNQKTeQLMoqI',
  coinbaseCommerceCheckoutId: '916f2077-72a2-4a12-afeb-b751003ccb42',
  payPalClientId:
    'ARc3YhOrDTllKhISFySL0EBY2Lj5lmq9FXdK_q98H8_8C4nrjifsWfRWhJFo8-JY5Lb3teDHXo6luMRR',
  payPalEnv: 'sandbox',
}



// WEBPACK FOOTER //
// ./src/config/dev.js